import { api } from '@/lib/api';
import type {
  BulkImportIntensiveClassRow,
  IndividualIntensiveClass,
  IndividualIntensiveClassInput,
  IntensiveClassSession,
  IntensiveClassSessionInput,
} from '@lentera/shared';

export const intensiveClassApi = {
  // Sesi
  listSessions: () => api.get<IntensiveClassSession[]>('/intensive-classes/sessions'),
  updateSessions: (sessions: IntensiveClassSessionInput[]) =>
    api.put<IntensiveClassSession[]>('/intensive-classes/sessions', { sessions }),

  // Peserta
  listParticipants: (params?: { q?: string; status?: string }) => {
    const search = new URLSearchParams();
    if (params?.q) search.set('q', params.q);
    if (params?.status) search.set('status', params.status);
    const qs = search.toString();
    return api.get<IndividualIntensiveClass[]>(`/intensive-classes/participants${qs ? `?${qs}` : ''}`);
  },

  getByIndividual: (individualId: string) =>
    api.get<{
      individual: { id: string; code: string; name: string; tbmId: string | null; photoKey: string | null };
      record: IndividualIntensiveClass | null;
      sessions: IntensiveClassSession[];
    }>(`/intensive-classes/by-individual/${individualId}`),

  upsert: (data: IndividualIntensiveClassInput) =>
    api.post<IndividualIntensiveClass>('/intensive-classes', data),

  update: (id: string, data: Partial<IndividualIntensiveClassInput>) =>
    api.patch<IndividualIntensiveClass>(`/intensive-classes/${id}`, data),

  remove: (id: string) => api.del<{ success: boolean; id: string }>(`/intensive-classes/${id}`),

  // Impor CSV
  importBulk: (rows: BulkImportIntensiveClassRow[]) =>
    api.post<{
      total: number;
      imported: number;
      failed: number;
      errors: string[];
    }>('/intensive-classes/import', { rows }),

  // E-Sertifikat
  uploadCertificate: async (individualId: string, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post<{
      record: IndividualIntensiveClass;
      attachmentId: string;
      fileKey: string;
      fileName: string;
    }>(`/intensive-classes/${individualId}/certificate`, formData);
  },

  deleteCertificate: (individualId: string) =>
    api.del<{ success: boolean }>(`/intensive-classes/${individualId}/certificate`),
};
